import type {
  CustomerType,
  ListReviewsParams,
  ReviewHubQueryParams,
} from '@frodo/models/types';

const serializeArrayParam = <T>(value?: T[]): string | undefined => {
  if (!value || value.length === 0) {
    return undefined;
  }

  return value.join(',');
};

export const buildReviewHubQueryParams = (
  params: ListReviewsParams,
): ReviewHubQueryParams => {
  const queryParams = {
    page: params.page,
    limit: params.limit,
    sort: params.sort,
    ratings: serializeArrayParam(params.ratings),
    customerType: serializeArrayParam(params.customerType),
    industryIds: serializeArrayParam(params.industryIds),
  };

  return Object.fromEntries(
    Object.entries(queryParams).filter(([, value]) => value !== undefined),
  ) as ReviewHubQueryParams;
};

export const normalizeCustomerType = (
  customerType?: string | null,
): CustomerType | undefined => {
  const normalizedCustomerType = customerType?.toLowerCase();

  return normalizedCustomerType === 'b2b' || normalizedCustomerType === 'b2c'
    ? normalizedCustomerType
    : undefined;
};
